<ng-container *ngIf="cart$ | async as cart">
  <div
    class="view-cart"
    *ngIf="cart && cart.count"
    (click)="emitReviewEvent()"
    attr.aria-label="{{ 'checkout' | translate }}"
  >
    <ng-container *ngIf="locationStatus$ | async as locationStatus">
      <div class="view-order" *ngIf="locationStatus &&
            locationStatus.isOpenToday &&
            locationStatus.isCurrentlyOpen"
          (click)="viewReview.emit()" id="viewOrderBtn"
          >
        {{ 'checkout' | translate }}
        ({{ cart?.count }} {{ itemText(cart.count) | translate }})
      </div>
      <div class="view-order-text" *ngIf="locationStatus && (!locationStatus.isOpenToday || !locationStatus.isCurrentlyOpen)">
          {{ locCloseMsg | translate }}
      </div>
    </ng-container>
  </div>
</ng-container>
